import { Box, Modal, Typography } from '@mui/material'
import React from 'react'
import CloseIcon from '@mui/icons-material/Close'

import useStylesRestoreModal from './useStylesRestoreModal'
import { useDispatch } from 'react-redux'
import { restoreDocuments } from '../../../redux/actions/Storage'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  height: 200,
  bgcolor: 'white',
  p: 4,
  borderRadius: '8px',
  boxShadow: '0px 0px 4px rgba(36, 55, 143, 0.4)'
}

export default function RestoreModal ({
  open,
  setOpen,
  ids,
  getRecycleRequest,
  setLoading
}) {
  const classes = useStylesRestoreModal()
  const handleClose = () => setOpen(false)
  const dispatch = useDispatch()

  const handleRestoreDocument = async () => {
    handleClose()
    setLoading(true)
    await dispatch(restoreDocuments(ids))
    setTimeout(() => {
      getRecycleRequest()
      setLoading(false)
    }, 5000)
  }

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <CloseIcon
            sx={{
              fontSize: 'medium',
              ml: 50,
              color: '#263057',
              cursor: 'pointer'
            }}
            onClick={handleClose}
          />

          <Typography
            sx={{ fontFamily: 'Raleway', color: '#263057' }}
            id="modal-modal-title"
            variant="h6"
            component="h2"
          >
            Confirmar restaurar documento{ids.length > 1 ? 's' : ''}
          </Typography>
          <Typography
            id="modal-modal-description"
            className={classes.typography}
          >
            ¿Está seguro de que desea restaurar
            {ids.length > 1 ? ' los' : ' el'} documento
            {ids.length > 1 ? 's' : ''}?
          </Typography>
          <Box className={classes.buttons}>
            <ButtonConfirm handleRestoreDocument={handleRestoreDocument} />
            <ButtonClose handleClose={handleClose} />
          </Box>
        </Box>
      </Modal>
    </div>
  )
}
function ButtonClose ({ handleClose }) {
  const classes = useStylesRestoreModal()
  return (
    <Box className={classes.closeButton}>
      <Typography
        onClick={() => {
          handleClose()
        }}
        className={classes.closeButtonColor}
      >
        Cerrar
      </Typography>
    </Box>
  )
}
function ButtonConfirm ({ handleRestoreDocument }) {
  const classes = useStylesRestoreModal()
  return (
    <Box
      className={classes.confirmButton}
      sx={{
        '&:hover': {
          bgcolor: '#1BF57F'
        }
      }}
    >
      <Typography
        onClick={handleRestoreDocument}
        className={classes.confirmButtonTypography}
      >
        Confirmar
      </Typography>
    </Box>
  )
}
